var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"value":true,"persistent":"","max-width":"800px"},on:{"click:outside":function($event){return _vm.$emit('close')}}},[_c('v-card',[_c('div',{staticClass:"py-10 px-8"},[_c('div',{staticClass:"pa-16 subtitle-1",domProps:{"innerHTML":_vm._s(_vm.html)}})])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }